import React from 'react';
import styled from 'styled-components';
import { color as themeColor } from 'theme';

interface Fredcon26PartnerBadgeProps {
  text: string;
  className?: string;
  style?: React.CSSProperties;
}

const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  position: relative;
  min-height: 40px;
  max-width: 100vw;
`;

const Head = styled.div`
  width: 40px;
  background: url('/images/fredcon26/partner-badge-head.svg') no-repeat center;
  background-size: 100% 100%;
  transform: rotate(180deg);
  flex-shrink: 0;
  margin-right: -2px; /* Overlap with body to hide gaps */
  position: relative;
  z-index: 1;
`;

const Body = styled.div`
  background-color: #3053f9;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  position: relative;
  z-index: 0;
  max-width: calc(100vw - 80px);

  p {
    font-family: 'Archivo Narrow', sans-serif;
    font-weight: 600;
    font-size: clamp(19px, 2vw, 24px);
    color: ${themeColor('white')};
    line-height: 1.2;
    margin: 0;
    text-transform: uppercase;
    white-space: normal;
    text-align: center;
  }
`;

const Tail = styled.div`
  width: 40px;
  background: url('/images/fredcon26/partner-badge-tail.svg') no-repeat center;
  background-size: 100% 100%;
  flex-shrink: 0;
  margin-left: -2px;
  position: relative;
  z-index: 1;
`;

export const Fredcon26PartnerBadge: React.FC<Fredcon26PartnerBadgeProps> = ({
  text,
  className,
  style
}) => {
  return (
    <Wrapper className={className} style={style}>
      <Head />
      <Body>
        <p>{text}</p>
      </Body>
      <Tail />
    </Wrapper>
  );
};
